import { Box } from "@mui/material";
import { HeroSectionComponent } from "../components/HeroSectionComponent";
import ServiceImage from "../assets/serviceHero.webp";
import { textlanguages } from "../data/textOfThePage";
import { useLanguageContext } from "../context/languageContext";
import ServicesSection from "../components/landing/section-services/ServicesSection";
import { capitalizeFirstLetter } from "../helpers/capitalizeFirstLetter";

export const ServicesPage = () => {
  const { languageSelected } = useLanguageContext();
  const serviceText = textlanguages[languageSelected].header[0].service;
  return (
    <Box>
      <HeroSectionComponent
        image={ServiceImage}
        text={capitalizeFirstLetter(serviceText)}
      />
      <ServicesSection />
    </Box>
  );
};
